<template>
  <div>
    <card class="card" title="Edit Profile">
      <div>
        <form @submit.prevent>
          <div class="row">
            <div class="col-md-6">

              <fg-input type="text"
                        label="Name"
                        placeholder="Name"
                        v-model="user.user_name">
              </fg-input>
            </div>
            <div class="col-md-6">
              <fg-input type="email"
                        label="Email"
                        placeholder="Email"
                        v-model="user.email" disabled>
              </fg-input>
            </div>
          </div>

          <div class="text-center">
            <p-button type="info"
                      round
                      @click.native.prevent="updateProfile">
              Update Profile
            </p-button>
          </div>
          <div class="clearfix"></div>
        </form>
        
      </div>
    </card>
    <card class="card" title="Aplikimet e mia">
      <div class="row">

          <table class="table">
            
            <thead>
              <tr>
                <th>Url</th>
                <th>Hyr</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in aplikimet" :key="item.ew_app_id">
                <td>{{item.ew_url}}</td>
                <td><a :href="`https://${item.ew_url}`">Akses</a></td>
              </tr>
            </tbody>
          </table>
        </div>
    </card>
  </div>
</template>
<script>
import API from '../../services/api.js';

export default {
  props: ['user'],
  data() {
    return {
      usertest: {},
      aplikimet:[]
    };
  },
  created(){
    this.usertest = this.user
    this.getAplikimet()
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.loggedIn;
    },
    userLogin() {
      return this.$store.state.auth.user;
    }
  },
  methods: {
    updateProfile() {
      API.put(`/user/${this.userLogin.email}/db`,{data: this.user})
      .then(response => {
        this.$notification.open({
          message: "Success",
          description: "Profile updated!",
        });
      })
    },
    getAplikimet(){
      API.get(`/user/${this.userLogin.email}/aplikimet`)
      .then(response => {
        this.aplikimet = response.data
      })
    }
  }
};
</script>
<style>
</style>
